import React, { Component } from 'react'
import './AddSigneePopup.scss';
import Select from '../../components/Select';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';
import { connect } from 'react-redux';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectValidation } from '../../store/selectors/Validation';
import { bindActionCreators } from 'redux';
import { clearValidation } from '../../store/actions/validation';
import { selectSuiteUsers } from '../../store/selectors/suiteUsers';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Tile from '../../components/Tile';
import Row from '../../components/Row';
import Input from '../../components/Input';
import Col from '../../components/Col';



class AddSigneePopup extends Component {
    state = {
        selectedHomeOwnerId: '',
        description: '',
        formType: 'Existing',
        firstName: '',
        lastName: '',
        role: '',
        email: ''
    }
    componentDidMount () {
    }
    onClickButton = (type) => {
        if(type === 'cancel') {
            this.props.onSubmitPopup(type)
        } else {
            if(this.state.formType === 'New') {
                let params = {
                    role: this.state.role,
                    signature: '',
                    firstname: this.state.firstName,
                    lastname: this.state.lastName,
                    email: this.state.email,
                    signType: '',
                   }
                this.props.onSubmitPopup(type, params, this.state.formType)
            } else {
                this.props.onSubmitPopup(type, this.state.selectedHomeOwnerId)
            }
        }
    }
    render() {
        return (
            <div className='app'>
                <div className='popup'>
                <Row mdCenter>
                {[ "Existing", 'New'].map(type =>
                      <>
                        <div style={{ padding: '0.5rem', flexDirection: 'row' }}>
                          <Tile
                            onClick={e => this.setState({ formType: type})}
                            active={type === this.state.formType}
                            title={type}
                            size="veryTiny"
                          />
                        </div>
                      </>
                    )}
                    </Row>
                    {this.state.formType === 'Existing' ? 
                    <Select
                        value={this.state.selectedHomeOwnerId}
                        onChange={e => this.setState({ selectedHomeOwnerId: e.target.value })}
                        options={this.props.suiteUsers.map(user => ({ value: user.id, label: user.firstname + ' ' + user.lastname }))}
                        label="Select Existing HomeOwner"
                        placeholder="(Select Existing HomeOwner)"
                        block
                    />
                    : 
                    <>
                        <Row>
                            <Col
                            xs="12"
                            md="12"
                            >
                            <Input
                            value={this.state.firstName}
                            onChange={e => this.setState({ firstName: e.target.value })}
                            placeholder="First Name"
                            block
                            // errors = {this.state.errors.city}
                            />
                            </Col>
                            <Col
                                xs="12"
                                md="12"
                                >
                             <Input
                                value={this.state.lastName}
                                onChange={e => this.setState({ lastName: e.target.value })}
                                placeholder="Last Name"
                                block
                                // errors = {this.state.errors.province}
                                />
                                </Col>
                                <Col
                                    xs="12"
                                    md="12"
                                    >
                                 <Input
                                   value={this.state.role}
                                   onChange={e => this.setState({ role: e.target.value })}
                                    placeholder="Role"
                                    block
                                  // errors = {this.state.errors.city}
                                  />
                                  </Col>
                                  <Col
                                    xs="12"
                                    md="12"
                                    >
                                   <Input
                                    value={this.state.email}
                                    onChange={e => this.setState({ email: e.target.value })}
                                    placeholder="Email Address"
                                    block
                                  // errors = {this.state.errors.province}
                                  />
                                  </Col>
                        </Row>
                    </>}
                    <Row>
                    <Col xs="12" md="2">
                        <Button
                            color="complete_purple"
                            size="small"
                            label="Cancel"
                            onClick={() => this.onClickButton('cancel')}
                        />
                        </Col>
                        <Col xs="12" md="2">
                            <Button
                                color="teal"
                                size="small"
                                label="Submit"
                                onClick={() => this.onClickButton('submit')}
                                disabled={this.state.formType === 'Existing' && !this.state.selectedHomeOwnerId ? true : this.state.formType === 'New' && (!this.state.firstName || !this.state.lastName || !this.state.role || !this.state.email) ? true : false}
                            />
                            </Col>
                            </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    suiteUsers: selectSuiteUsers(state),
    user : selectAuthenticatedUser(state),
    validation: selectValidation(state),
    loader: selectPRLoader(state),
  });
  const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
      clearValidation: clearValidation
    },dispatch
  );
  export default connect(mapStateToProps, mapDispatchToProps)(AddSigneePopup);
